
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  position: relative;
  display: block;
  height: 0px;
  padding-bottom:calc(9 / 16 * 100%);
}

@media (min-width: 640px) {

  :host {
    padding-bottom: 360px;
  }
}

:host{
  max-width:640px;
}

iframe {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: block;
  height: 100%;
  width: 100%;
}

@media (min-width: 640px) {

  iframe {
    height: 360px;
  }
}

.video-thumb {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-color: var(--neutral-black);
}

.video-thumb img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: center;
}

.video-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 20;
  height: 100%;
  width: 100%;
  background-color: var(--gray-professional-darken-2);
  opacity: 0.4;
}

.slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
  position: absolute;
}

.slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
  margin: auto;
}

.slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
  aspect-ratio: 1.47;
}

.slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
  width: 100%;
}

@media (min-width: 768px) {

  .slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
    aspect-ratio: 2;
  }
}

@media (min-width: 768px) {

  .slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
    height: 100%;
  }
}

@media (min-width: 768px) {

  .slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
    max-height: 250px;
  }
}

@media (min-width: 1024px) {

  .slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
    height: 100%;
  }
}

@media (min-width: 1024px) {

  .slider-child iframe, .slider-child .video-thumb, .slider-child .video-overlay {
    max-height: 100%;
  }
}

.slider-child .video-thumb img {
  object-fit: cover;
}

.slider-child iframe {
  position: relative;
}

.slider-child iframe {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.slider-child iframe {
  aspect-ratio: 1.47;
}

@media (min-width: 768px) {

  .slider-child iframe {
    position: absolute;
  }
}

button{
  background:none;
  border:none;
}

.video-play {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 20;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

idb-icon {
  cursor: pointer;
  font-size: var(--fs-5xl);
  line-height: var(--lh-5xl);
  color: var(--neutral-white);
}

idb-icon:hover {
  color: var(--blue-responsible-darken-2);
}

.hide {
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s linear 300ms, opacity 300ms;
}
`;